export default [
  {
    title: 'breadcrumb.requestDeposit',
    route: 'request-deposit',
    icon: '',
    resource: 'request-deposit',
    action: 'read'
  }
];